import { useOnboardingTexts } from "src/routes/onboarding/shared/hooks/useOnboardingTexts";
import { BreakdownWithEmoji } from "../../../../shared";
import { SOMATIC_KEYS } from "../../../../shared";
import like from "@assets/img/emoji/like.png";

const dataAges = {
  "18-29": "20s",
  "30-39": "30s",
  "40-49": "40s",
  "50+": "50s",
};

function formatPhrases(phrases) {
  const lowercasedPhrases = phrases.map((phrase) => phrase.toLowerCase());

  if (lowercasedPhrases.length === 1) {
    return lowercasedPhrases[0];
  } else if (lowercasedPhrases.length === 2) {
    return lowercasedPhrases.join(" and ");
  } else {
    const allButLastTwo = lowercasedPhrases.slice(0, -2).join(", ");
    const lastTwo = lowercasedPhrases.slice(-2).join(" and ");
    return `${allButLastTwo}, ${lastTwo}`;
  }
}

export const TransformBody = ({ onNextStep, onTrackEvent }) => {
  const { getSectionText } = useOnboardingTexts();

  const title = getSectionText("feedback_weight_goal2").title;
  const description = getSectionText("feedback_weight_goal2").description;

  const ages = localStorage.getItem(SOMATIC_KEYS.ageStart);
  const value = localStorage.getItem(SOMATIC_KEYS.hopeToAchieve);
  const options = JSON.parse(value);
  const content = formatPhrases(options);
  const paragraph = [
    `For woman in their ${dataAges[ages]} exercise workouts are a great tool to <strong>${content}.</strong>`,
    description,
  ];
  return (
    <BreakdownWithEmoji
      title={title}
      paragraph={paragraph}
      emoji={like}
      onContinue={() => {
        onNextStep();
        onTrackEvent();
      }}
    />
  );
};
